import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=244f1d31&scoped=true&"
import script from "./MemberEdit.vue?vue&type=script&lang=js&"
export * from "./MemberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244f1d31",
  null
  
)

export default component.exports